import { BusinessDateParams } from "app/models/business-date-params";

export const getBusinessDate = (state: { businessDate: { curBusinessDate: Date; }; }) => state.businessDate.curBusinessDate ?? new Date();

export const getBusinessDateInfo = (state: { businessDate: { businessDateInfo: BusinessDateParams; }; }) => state.businessDate.businessDateInfo;
